<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['add_marks_entry']">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2">
              <div class="row">
                <b-form-group class="col-md-2 px-1" label="Class">
                  <v-select
                    :options="schoolclasses.filter((c) => c.level == 1)"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2 px-1" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2 px-1" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    @input="FilterExams"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2 px-1" label="Exam">
                  <v-select
                    :options="exams"
                    placeholder="Select Exam"
                    v-model="exam"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3 px-1" label="Combination">
                  <v-select
                    :options="combinations"
                    placeholder="Select Combination"
                    v-model="combination"
                    label="comb"
                  ></v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter</b-button
                  >
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <span class="text-center h4"
                  >{{ schoolclass.name }} {{ schoolsubject.name }}
                  {{ exam.name }}, {{ schoolterm.name }} {{ year }} -
                  <b>{{ combination.comb }}</b></span
                >
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_photo)="data">
                    <img
                      :src="getFiles(data.item.students.student_photo)"
                      height="50"
                    />
                  </template>
                  <template #cell(student_id)="data">
                    <b class="text-danger">{{
                      data.item.students.student_id
                    }}</b>
                    <br />
                    {{ data.item.students.first_name }}
                    {{ data.item.students.last_name }}
                  </template>
                  <template #cell(mark)="data">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th>Subject</th>
                          <th>P1</th>
                          <th>P2</th>
                          <th>P3</th>
                          <th>P4</th>
                          <th>Grade</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="x in data.item.subjects" :key="x.subject.id">
                          <td>{{ x.subject.name }}</td>
                          <td>
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                            >
                              <span v-if="detail.paper.name == 'P1'">{{
                                detail.mark
                              }}</span>
                            </span>
                            <!-- <span v-if="!x.details.some(d => d.paper.name === 'P1')">-</span> -->
                          </td>
                          <td>
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                            >
                              <span v-if="detail.paper.name == 'P2'">{{
                                detail.mark
                              }}</span>
                            </span>
                          </td>
                          <td>
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                            >
                              <span v-if="detail.paper.name == 'P3'">{{
                                detail.mark
                              }}</span>
                            </span>
                          </td>
                          <td>
                            <span
                              v-for="detail in x.details"
                              :key="detail.paper.id"
                            >
                              <span v-if="detail.paper.name == 'P4'">{{
                                detail.mark
                              }}</span>
                            </span>
                          </td>
                          <td>
                            <span v-if="x.details.length > 0">
                              {{ calculateSubjectGrade(x) }}
                            </span>
                            <span v-else class="text-muted">-</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <template #cell(points)="data">
                    <span
                      ><strong style="text-align:center;">{{
                        calculateTotalPoints(data.item)
                      }}</strong>
                      points</span
                    >
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  combinationsComputed,
  combinationsMethods,
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Exam Marks",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Exam Marks",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Exam Marks", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student_photo", label: "Photo", visible: true },
        { key: "student_id", label: "Student ID", visible: true },
        { key: "mark", label: "Marks", visible: true },
        { key: "points", label: "Points", visible: true },
      ],
      id: "",
      schoolsubjects: [],
      schoolsubject: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      exams: [],
      mark: "",
      year: new Date().getFullYear(),
      points: "",
      combination: "",
      exammarks: [],
    };
  },
  computed: {
    ...schooltermComputed,
    ...schoolclassComputed,
    ...combinationsComputed,
    List() {
      return this.exammarks.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.exammarks.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.exammarks.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.fetchCombinations();
    this.TotalRows = this.exammarks.length;
    this.isBusy = false;
  },
  methods: {
    ...schooltermMethods,
    ...schoolclassMethods,
    ...combinationsMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async FilterExams() {
      let url = `/findschoolexam/${this.schoolterm.id},${this.year},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.exams = response.data.exams;
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("exam", this.exam.id);
      formData.append("combination", this.combination.comb);
      let url = "/viewalevelmarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.alevelmarks;
      });
    },
    async changeMark(mark, id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("mark", mark);
      let url = "/updateexammarks";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.id = id;
        }
      });
    },

    calculateSubjectGrade(subject) {
      const grades = subject.details.map((d) => d.grade);
      //Subsidiary
      if (subject.subject.stat === 2) {
        return grades.some((g) => g >= 7) ? "0" : "1";
      }
      //Majors
      const paperCount = grades.length;

      if (paperCount === 2) {
        if (grades.every((g) => g <= 2)) return "A";
        if (grades.every((g) => g <= 3)) return "B";
        if (grades.every((g) => g <= 4)) return "C";
        if (grades.every((g) => g <= 5)) return "D";
        if (
          grades.every((g) => g <= 6) ||
          (grades.reduce((a, b) => a + b) <= 12 && grades.some((g) => g >= 7))
        )
          return "E";
        if (
          grades.reduce((a, b) => a + b) <= 16 ||
          (grades.some((g) => g <= 6) && grades.some((g) => g === 9))
        )
          return "O";
        return "F";
      } else if (paperCount === 3) {
        if (
          Math.max(...grades) <= 3 &&
          grades.filter((g) => g <= 2).length >= 2
        )
          return "A";
        if (Math.max(...grades) <= 4) return "B";
        if (Math.max(...grades) <= 5) return "C";
        if (Math.max(...grades) <= 6) return "D";
        if (grades.some((g) => g === 7) && grades.every((g) => g <= 7))
          return "E";
        if (
          grades.every((g) => g === 7) ||
          grades.every((g) => g === 8) ||
          (grades.filter((g) => g === 9).length === 1 &&
            grades.filter((g) => g <= 8).length === 2)
        )
          return "O";
        return "F";
      } else if (paperCount === 4) {
        if (
          Math.max(...grades) <= 3 &&
          grades.filter((g) => g <= 2).length >= 3
        )
          return "A";
        if (Math.max(...grades) <= 4) return "B";
        if (Math.max(...grades) <= 5) return "C";
        if (Math.max(...grades) <= 6) return "D";
        if (grades.some((g) => g === 7) && grades.every((g) => g <= 7))
          return "E";
        if (
          grades.every((g) => g === 7) ||
          grades.every((g) => g === 8) ||
          (grades.filter((g) => g === 9).length === 1 &&
            grades.filter((g) => g <= 8).length === 3) ||
          (grades.filter((g) => g === 9).length === 2 &&
            grades.filter((g) => g <= 7).length === 2)
        )
          return "O";
        return "F";
      }

      return "F";
    },

    calculateSubjectPoints(subject) {
      const grade = this.calculateSubjectGrade(subject);

      // principal subjects
      if (subject.subject.stat === 1) {
        switch (grade) {
          case "A":
            return 6;
          case "B":
            return 5;
          case "C":
            return 4;
          case "D":
            return 3;
          case "E":
            return 2;
          case "O":
            return 1;
          case "F":
            return 0;
          default:
            return 0;
        }
      }
      // subsidiary subjects
      else if (subject.subject.stat === 2) {
        const allPass = subject.details.every((detail) => detail.grade <= 6);
        return allPass ? 1 : 0;
      }
      return 0;
    },

    calculateTotalPoints(student) {
      let totalPoints = 0;

      if (student.subjects && student.subjects.length > 0) {
        student.subjects.forEach((subject) => {
          totalPoints += this.calculateSubjectPoints(subject);
        });
      }
      return totalPoints;
    },
  },
};
</script>
